import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DevicesService } from '../../../entities/devices/devices.service';
import { ApiService } from '../../../core/services/api.service';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-is-alive',
  templateUrl: './is-alive.component.html',
  styleUrls: ['./is-alive.component.scss']
})
export class IsAliveComponent implements OnInit {

  constructor(private router: Router,
              private apiService: ApiService,
              private generalService: GeneralService) { }

  ngOnInit() {
  }

  isAliveState() {
    return true;
  }

  refresh() {
    if (this.isAliveState()) {
      this.router.navigate(['/']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/is-alive/is-alive.component.ts